var React = require('react');

function ToolAngular (props) {
    return React.createElement("svg",props,[React.createElement("g",{"className":"fill-background","key":0},[React.createElement("polygon",{"points":"12,8.9 12,12.5 13.5,12.5 \t","key":0}),React.createElement("polygon",{"points":"12,3.2 12,5.1 17.1,16.6 15.2,16.6 14.2,14.1 12,14.1 12,20.8 18.9,17 20.2,6.1 \t","key":1})]),React.createElement("g",{"className":"fill-foreground","key":1},[React.createElement("polygon",{"points":"3.8,6.1 5.1,17 12,20.8 12,14.1 9.8,14.1 8.8,16.6 6.9,16.6 12,5.1 12,3.2 \t","key":0}),React.createElement("polygon",{"points":"12,12.5 12,8.9 10.5,12.5 \t","key":1})])]);
}

ToolAngular.defaultProps = {"version":"1.0","width":"48","height":"48","viewBox":"0 0 24 24"};

module.exports = ToolAngular;

ToolAngular.default = ToolAngular;
